export default class snRealTimeMixplantCtrl{
    constructor(snRealTimeService,$rootScope,$interval){
        this.service = snRealTimeService
        this.rootScope = $rootScope
        this.outPutList = []
        this.interval = $interval
    }
    $doCheck(){
        //当且仅当换拌和楼是查询
        if(this.terms == null){
            return
        }
        if(this.preMixplantId != this.terms.mixplantId){
            this.fetchAnalyzeData()
        }
        this.preMixplantId = this.terms.mixplantId
    }

    $onInit(){
        this.startTimer()
    }

    $onDestroy(){
        console.log('mixplant   onDestry')
        this.interval.cancel(this.timer)
    }



    startTimer(){
        let that = this
        this.timer =  this.interval(function(){
            that.fetchAnalyzeData()
        },30*1000)
    }


    //取30分钟内 最新的一条数据
    fetchAnalyzeData(){
        let terms = this.terms
        // console.log(terms,'terms')
        if(terms.mixtureId == null){
            return
        }
        let param = {
            'sectionId':terms.sectionId,
            'workAreaId':terms.workAreaId,
            'mixplantId':terms.mixplantId,
            'mixtureId':terms.mixtureId,
            'startDateTime':terms.startDateTime,
            'endDateTime':terms.endDateTime
        }

        this.service.fetchRealTimeOutput(param).then(res=>{
            // console.log('实时:')
            // console.log(res)
            this.outPutList = res.second
            this.rootScope.dischargeDate = res.first
            this.rootScope.projectParts = res.projectParts
            this.rootScope.mixTime = res.mixTime
            this.rootScope.volume = res.volume.toFixed(2)

        })
    }

    get mixTime(){
        return this.rootScope.mixTime
    }
}

snRealTimeMixplantCtrl.$inject = ['snRealTimeService','$rootScope',"$interval"]
